import initLightbox from "./lightbox";

document.addEventListener("DOMContentLoaded", () => {
  initLightbox();
});
